// #region COMPONENTS COMPOSABLES
import PendingRequest from '../views/pending-request/PendingRequest.vue';
// #endregion

export default [
  {
    path: '/solicitud-pendiente',
    name: 'PendingRequest',
    component: PendingRequest,
    meta: {
      title: 'Solicitud pendiente',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajeros de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
        {
          key: 'main',
          dynamic: true,
          // text: '',
          // link: STTEDRA_URL_AMPLIFY_INFORMATION || 'https://www.transportes.gob.es/transporte_terrestre/verano-joven',
          link: '',
          route: 'Home',
        },
        {
          text: 'Solicitud Pendiente',
          link: '',
        },
      ],
    },
  },
];
